module.exports = __webpack_public_path__ + "img/menu-video.28a6e004.svg";